import "./style.css";
import Modal from "components/Modal";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FormProvider } from "react-hook-form";
import { useModalStore, Modal as ModalKey } from "stores/modal/useModalStore";
import { useAuthStore } from "stores/auth/authStore";
import { ProfileHeader } from "./ProfileHeader";
import { ContactInformation } from "./ContactInformation";
import { AddressInformation } from "./AddressInformation";
import { ActionButtons } from "./ActionButtons";
import { GoogleApiWrapper } from "google-maps-react";
import { useProfileForm } from "hooks/useProfileForm";

export const ProfileModal = () => {
  const navigate = useNavigate();
  const [isDropdownActive, setIsDropdownActive] = useState(false);

  const close = useModalStore(s => s.close);
  const current = useModalStore(s => s.current);
  const openOverlay = useModalStore(s => s.openOverlay);
  const isOpen = current === ModalKey.Profile;

  const user = useAuthStore((state) => state.user);

  const {
    methods,
    isLoading,
    selectedSize,
    selectedPlace,
    hasAddress,
    placeAutocomplete,
    countryState,
    countryCity,
    countryZipcode,
    aptOrSuite,
    imageResult,
    handleSubmit,
    handlePhoneNumberChange,
    handleSizeChange,
    setSelectedPlace,
    setters,
  } = useProfileForm(navigate);

  const { isDirty } = methods.formState;

  return (
    <FormProvider {...methods}>
      <Modal
        shouldCloseOnOverlayClick={hasAddress}
        modalIsOpen={isOpen}
        closeModal={close}
        className={`w-[500px] mx-auto sm:mx-0 sm:w-full max-h-[1000px] p-10 
        ${isDropdownActive ? "!overflow-y-hidden" : "!overflow-y-scroll"}
        lg:!max-w-[1400px]`}
      >
        <form onSubmit={handleSubmit}>
          <div className="!w-full h-auto">
            <ProfileHeader
              user={user}
              imageResult={imageResult}
              onUploadClick={() => openOverlay(ModalKey.Upload)}
            />

            <div className="mt-[20px] md:mt-[35px]">
              <p className="contact_text capitalize md:block hidden">
                Contact Information
              </p>

              <ContactInformation
                selectedSize={selectedSize}
                handleSizeChange={handleSizeChange}
                handlePhoneNumberChange={handlePhoneNumberChange}
              />

              <AddressInformation
                methods={methods}
                placeAutocomplete={placeAutocomplete}
                selectedPlace={selectedPlace}
                setSelectedPlace={setSelectedPlace}
                isDropdownActive={isDropdownActive}
                setIsDropdownActive={setIsDropdownActive}
                setters={setters}
                countryState={countryState}
                countryCity={countryCity}
                countryZipcode={countryZipcode}
                aptOrSuite={aptOrSuite}
              />

              <div className="border-b-2 border-dashed border-[#9C765B] mt-[20px]" />

              <ActionButtons
                isLoading={isLoading}
                isDirty={isDirty}
                hasAddress={hasAddress}
                onCancel={close}
              />
            </div>
          </div>
        </form>
      </Modal>
    </FormProvider>
  );
};

export default GoogleApiWrapper({
  apiKey: import.meta.env.VITE_GOOGLE_API_KEY,
  LoadingContainer: "div",
})(ProfileModal);
